import { createFileRoute } from '@tanstack/react-router'
import MarketingModelosEmailsPage from '@/pages/dashboard/marketing-modelos-emails-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/',
)({
  component: function MarketingModelosEmailsIndexRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingModelosEmailsPage />
      </RequireModule>
    )
  },
})
